/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

import React from "react"

import FooterProps from "./FooterProps"
import "./Footer.scss"

const Footer: React.FC<FooterProps> = ({appName, links}) => {
    return (
        <div className="Footer">
            <div>{appName ? <span>{appName}</span> : null}</div>
            <div className="Copyright">
                <span>{`© ${new Date().getFullYear()} biocrates life sciences ag`}</span>
            </div>
            <div className="Links">
                <ul>
                    {links.map((link) => (
                        <li key={link.label}>
                            <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={link.href}
                            >
                                {link.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default Footer
